module.exports = __webpack_public_path__ + "static/media/capa.bf4fcfab.jpg";